export function contactQueryParams(url: string, category: string, subject?: string): string {
    const subjectPart = subject ? `&subject=${subject}` : '';
    return `/${url}?category=${category}${subjectPart}`;
}
